export default "__VITE_ASSET__No_03Fvu__"